import React, { useState } from 'react';
import styled from 'styled-components';
import Panel from './Panel';
import PeriodSelector from './PeriodSelector';
import useMonitoringData from '../hooks/useMonitoring';
import { fetchUserActivity } from '../api/monitoringApi';

const Table = styled.table`width: 100%; border-collapse: collapse; font-size: 13px;`;
const Th = styled.th`text-align: left; padding: 6px 8px; background: #f9fafb; border-bottom: 1px solid #e5e7eb; color: #6b7280; font-weight: 600;`;
const Td = styled.td`padding: 6px 8px; border-bottom: 1px solid #f3f4f6; color: #374151;`;
const ExpandRow = styled.tr`background: #f9fafb;`;
const ToggleBtn = styled.button`background: none; border: none; cursor: pointer; font-size: 12px; color: #667eea;`;

function fmtTime(iso) {
  if (!iso) return '-';
  return new Date(iso).toLocaleString('ko-KR', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export default function UserActivityPanel({ refreshKey }) {
  const [period, setPeriod] = useState('24h');
  const [expanded, setExpanded] = useState({});
  const { data, isLoading, error } = useMonitoringData(() => fetchUserActivity(period, 20), [period, refreshKey]);

  const toggle = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <Panel title="사용자 활동" isLoading={isLoading} error={error}
      actions={<PeriodSelector value={period} onChange={setPeriod} />}>
      <div style={{ overflowX: 'auto' }}>
        <Table>
          <thead><tr><Th></Th><Th>고객</Th><Th>이메일</Th><Th>요청 수</Th><Th>에러</Th><Th>평균 응답</Th><Th>마지막 활동</Th></tr></thead>
          <tbody>
            {data?.map((r, i) => (
              <React.Fragment key={i}>
                <tr>
                  <Td><ToggleBtn onClick={() => toggle(r.client_id)}>{expanded[r.client_id] ? '▼' : '▶'}</ToggleBtn></Td>
                  <Td>{r.client_name || '-'}</Td>
                  <Td>{r.client_email || '-'}</Td>
                  <Td>{r.total_requests}</Td>
                  <Td style={{color: r.error_count > 0 ? '#ef4444' : undefined}}>{r.error_count}</Td>
                  <Td>{r.avg_response_time}ms</Td>
                  <Td>{fmtTime(r.last_active)}</Td>
                </tr>
                {expanded[r.client_id] && r.top_endpoints?.length > 0 && (
                  <ExpandRow>
                    <td></td>
                    <td colSpan={6} style={{ padding: '4px 8px' }}>
                      <div style={{ fontSize: 12, color: '#6b7280' }}>
                        {r.top_endpoints.map((e, j) => (
                          <div key={j}>{e.method} {e.url} — {e.count}회</div>
                        ))}
                      </div>
                    </td>
                  </ExpandRow>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </div>
    </Panel>
  );
}
